/**
 * @generated SignedSource<<c71826baaa380360e0fa58df51648e00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoAssignee_todo$data = {
  readonly assignee: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "UserHandle_member">;
  } | null;
  readonly canAssign: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AssignTodoModal_todo">;
  readonly " $fragmentType": "TodoAssignee_todo";
};
export type TodoAssignee_todo$key = {
  readonly " $data"?: TodoAssignee_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoAssignee_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoAssignee_todo",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssignTodoModal_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserHandle_member"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatar_member"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canAssign",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "493b2d67448d4ab832456eb7da49566e";

export default node;
